import { isSameDay, subDays, subHours } from "date-fns";

const dateFormatter = new Intl.DateTimeFormat("da-DK", {
  month: "short",
  day: "numeric",
});

export const midnightOffsetHours = 6;

export function isWithinMidnightPeriod(d: Date) {
  // Between 00:00 and 06:00
  return d.getHours() >= 0 && d.getHours() <= midnightOffsetHours;
}

/**
 * Offsets b with the midnight period
 */
export function isSameDayWithinMidnightPeriod(a: Date, b: Date) {
  const _b = isWithinMidnightPeriod(b) ? subHours(b, midnightOffsetHours) : b;
  return isSameDay(a, _b);
}

/**
 * Adjusts the date, so that it's technically the day before.
 * DO NOT ACCOUNT FOR THE TIME, it's ONLY the date part that matters.
 *
 * If you pass in a date, that is 2025-12-25 00:00:00 it's technically the next day
 * however, when doing date math, we want to display it as 2025-12-24 00:00:00, event
 * though it's technically wrong
 *
 * This is based on human intuition and helps solve the case of new years
 * eve where the special opening hours are usually from 00:15 and forth which technically i s01-01-<thenextyear>
 */
export function adjustForMidnightPeriod(d: Date) {
  return isWithinMidnightPeriod(d) ? subDays(d, 1) : d;
}

// TODO: Maybe we should have something like Date -> DateOnly with adjusted dates

/** This is a cheat code to allow for the date to be displayed as the 31. even though it techically
 * is 1. of january.
 *
 * This allows for the venue manager to intuitively think about the dates
 * EVEN THOUGH they're techinally wrong.
 */
export function formatArrivalDate(arrivalDate: Date) {
  return dateFormatter.format(
    isWithinMidnightPeriod(arrivalDate) ? subDays(arrivalDate, 1) : arrivalDate
  );
}
